import { ref } from '@vue/composition-api'
import {
  mdiCalendarPlus,
  mdiProgressCheck,
  mdiCheckDecagram,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
  mdiMinusCircleOutline,
  mdiAlertCircleOutline,
} from '@mdi/js'

export default function useEventsStatusesList() {
  const eventsStatusesList = ref([
    {
      id: 1,
      text: 'Nuevo',
      color: '#80CBC4',
      icon: mdiCalendarPlus,
    }, {
      id: 2,
      text: 'En Seguimiento',
      color: '#81D4FA',
      icon: mdiProgressCheck,

    }, {
      id: 3,
      text: 'Garantizado',
      color: '#D4E157',
      icon: mdiCheckDecagram,

    }, {
      id: 4,
      text: 'Realizado',
      color: '#66BB6A',
      icon: mdiCheckCircleOutline,

    }, {
      id: 5,
      text: 'Cancelado',
      color: '#EF5350',
      icon: mdiCloseCircleOutline,
    }, {
      id: 6,
      text: 'No Show',
      color: '#FFD600',
      icon: mdiMinusCircleOutline,
    }, {
      id: 7,
      text: 'Cerrado',
      color: '#455A64',
      icon: mdiAlertCircleOutline,
    },
  ])

  const GetById = id => eventsStatusesList.value.find(item => item.id === id)

  return {
    eventsStatusesList,
    GetById,
  }
}
